import React from 'react'
import styles from './styles.css'
import Button from 'orionsoft-parts/lib/components/Button'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
@withMessage
@withMutation(gql`
  mutation signFromTemplate($templateId: ID) {
    createFromTemplate(templateId: $templateId) {
      _id
    }
  }
`)


@withRouter
export default class Ready extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    template: PropTypes.object,
    signFromTemplate: PropTypes.func,
    showMessage: PropTypes.func
  }

  state = {}

  renderCreateDocument(item) {
    return (
      <span
        onClick={() =>
          this.props.router.push(`/sign/prepare/template/${item._id}`)
        }
      >
        Ver Documento
      </span>
    )
  }

  async createDocument(item) {
    try {
      const doc = await this.props.signFromTemplate({
        templateId: item._id
      }, {
        refetchQueries: [
          'planSignaturesCount',
          'packsSignaturesCount'
        ]
      })
      this.props.router.push(`/documents/${doc.createFromTemplate._id}`)
      this.props.showMessage('Documento creado')
    } catch (e) {
      this.props.showMessage(e.message, { level: 'error' })
    } finally {
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <Button
          onClick={() =>
            this.props.router.push(
              `/sign/prepare/template/${this.props.template._id}`
            )
          }
        >
          Ver Template
        </Button>
        <Button
          primary
          enable={false}
          loading={this.state.loading}
          onClick={() => this.createDocument(this.props.template)}
        >
          crear documento{' '}
        </Button>
        <Button
          primary
          enable={false}
          loading={this.state.loading}
          onClick={() => this.props.router.push(`/templates/massivecreate/${this.props.template._id}`) }
        >
         Envío Masivo
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Templates/Template/Ready/index.js